import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

const StartDateTimeCell = ({ start_time_from, start_time_to, start_time_from_tz }) => (
  <Fragment>
    {moment(start_time_from).tz(start_time_from_tz).format('MMMM Do')}
    <br />
    {moment(start_time_from).tz(start_time_from_tz).format('HH:mm')} -{' '}
    {moment(start_time_to).tz(start_time_from_tz).format('HH:mm')}
  </Fragment>
);

StartDateTimeCell.propTypes = {
  start_time_from: PropTypes.string.isRequired,
  start_time_to: PropTypes.string.isRequired,
  start_time_from_tz: PropTypes.string.isRequired,
};

export default StartDateTimeCell;
